class SortManager {
    constructor(manager) {
        this._init(manager)
    }
    _init(manager) {
        this.el = document.querySelector('[data-sort]')
        this.manager = manager
        if(!this.el) {
            return
        }
        this.elSorts = this.el.querySelectorAll('[data-sort-id]')
        this.elSorts.forEach(el => {
            el.sort = new Sort(el, this, this.manager.params)
        })
    }
    setNewURL(newId) {
        // const params = this.createNewParams(newId)
        this.manager.sort = newId;
        this.manager.updateParams(params)
    }
	// createNewParams(newSort) {
    //     const mParams = this.manager.params
    //     mParams.set("sort", newSort)
	// 	return mParams
    // }
    update() {
        this.elSorts.forEach(el => el.sort.sortUpdate(this.manager.params))
    }
}
class Sort {
    constructor(el, manager, params) {
        this._init(el, manager, params)
    }
    _init(el, manager, params) {
        this.el = el
        this.manager = manager
        this.id = this.el.getAttribute('data-sort-id')
        if(!this.manager.firstId) {
            this.manager.firstId = this.id
        }
        this.el.addEventListener("click", () => this.onSortClick())
        this.sortUpdate(params)
    }
    onSortClick() {
        this.manager.setNewURL(this.id)
    }
    sortUpdate(mParams) {
        let currSort = mParams.get('sort')
        currSort = currSort ? currSort : this.manager.firstId
        this.setSelected(currSort === this.id)
    }
    setSelected(b) {
        if(b) {
            this.el.classList.add("order-by__option-is-active")
        } else {
            this.el.classList.remove("order-by__option-is-active")
        }
    }
}

export default SortManager
